// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/assets/img/hero-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public/assets/img/footer-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i|Nunito:300,300i,400,400i,600,600i,700,700i|Poppins:300,300i,400,400i,500,500i,600,600i,700,700i);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Colors */
:root {
  --color-default: #fafafa;
  --color-primary: #27a776;
  --color-secondary: #161718;
}

/* Smooth scroll behavior */
:root {
  scroll-behavior: smooth;
}

body {
  font-family: "Open Sans", sans-serif;
  color: #444444;
}
* {
  font-family: "Nunito", sans-serif;
}

a {
  color: #4154f1;
  text-decoration: none !important;
}

a:hover {
  color: #717ff5;
  text-decoration: none !important;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Nunito", sans-serif;
}

/*--------------------------------------------------------------
# Preloader
--------------------------------------------------------------*/
#preloader {
  display: flex;
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100vh;
  z-index: 99999;
}

#preloader:before,
#preloader:after {
  content: "";
  background-color: var(--color-secondary);
  position: absolute;
  inset: 0;
  width: 50%;
  height: 100%;
  transition: all 0.3s ease 0s;
  z-index: -1;
}

#preloader:after {
  left: auto;
  right: 0;
}

#preloader .line {
  position: relative;
  overflow: hidden;
  margin: auto;
  width: 1px;
  height: 280px;
  transition: all 0.8s ease 0s;
}

#preloader .line:before {
  content: "";
  position: absolute;
  background-color: #fff;
  left: 0;
  top: 50%;
  width: 1px;
  height: 0%;
  transform: translateY(-50%);
  animation: lineincrease 1000ms ease-in-out 0s forwards;
}

#preloader .line:after {
  content: "";
  position: absolute;
  background-color: #999;
  left: 0;
  top: 0;
  width: 1px;
  height: 100%;
  transform: translateY(-100%);
  animation: linemove 1200ms linear 0s infinite;
  animation-delay: 2000ms;
}

#preloader.loaded .line {
  opacity: 0;
  height: 100% !important;
}

#preloader.loaded .line:after {
  opacity: 0;
}

#preloader.loaded:before,
#preloader.loaded:after {
  animation: preloaderfinish 300ms ease-in-out 500ms forwards;
}

@keyframes lineincrease {
  0% {
    height: 0%;
  }

  100% {
    height: 100%;
  }
}

@keyframes linemove {
  0% {
    transform: translateY(200%);
  }

  100% {
    transform: translateY(-100%);
  }
}

@keyframes preloaderfinish {
  0% {
    width: 5 0%;
  }

  100% {
    width: 0%;
  }
}

/*--------------------------------------------------------------
# Sections
--------------------------------------------------------------*/
section {
  padding: 60px 0;
  overflow: hidden;
}

.section-header {
  text-align: center;
  padding-bottom: 40px;
}

.section-header h2 {
  font-size: 13px;
  letter-spacing: 1px;
  font-weight: 700;
  margin: 0;
  color: #4154f1;
  text-transform: uppercase;
}

.section-header p {
  margin: 10px 0 0 0;
  padding: 0;
  font-size: 38px;
  line-height: 42px;
  font-weight: 700;
  color: #012970;
}

@media (max-width: 768px) {
  .section-header p {
    font-size: 28px;
    line-height: 32px;
  }
}

/*--------------------------------------------------------------
# Breadcrumbs
--------------------------------------------------------------*/
.breadcrumbs {
  padding: 15px 0;
  background: #012970;
  min-height: 40px;
  margin-top: 82px;
  color: #fff;
}

@media (max-width: 992px) {
  .breadcrumbs {
    margin-top: 57px;
  }
}

.breadcrumbs h2 {
  font-size: 28px;
  font-weight: 500;
}

.breadcrumbs ol {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0 0 10px 0;
  margin: 0;
  font-size: 14px;
}

.breadcrumbs ol a {
  color: #fff;
  transition: 0.3s;
}

.breadcrumbs ol a:hover {
  text-decoration: underline;
}

.breadcrumbs ol li + li {
  padding-left: 10px;
}

.breadcrumbs ol li + li::before {
  display: inline-block;
  padding-right: 10px;
  color: #8894f6;
  content: "/";
}

/*--------------------------------------------------------------
# Back to top button
--------------------------------------------------------------*/
.back-to-top {
  position: fixed;
  visibility: hidden;
  opacity: 0;
  right: 15px;
  bottom: 15px;
  z-index: 99999;
  background: #4154f1;
  width: 30px;
  height: 30px;
  border-radius: 4px;
  transition: all 0.4s;
}

.back-to-top i {
  font-size: 24px;
  color: #fff;
  line-height: 0;
}

.back-to-top:hover {
  background: #6776f4;
  color: #fff;
}

.back-to-top.active {
  visibility: visible;
  opacity: 1;
}

/*--------------------------------------------------------------
# Disable aos animation delay on mobile devices
--------------------------------------------------------------*/
@media screen and (max-width: 768px) {
  [data-aos-delay] {
    transition-delay: 0 !important;
  }
}

/*--------------------------------------------------------------
# Header
--------------------------------------------------------------*/
.header {
  transition: all 0.5s;
  z-index: 997;
  padding: 20px 0;
}

.header.header-scrolled {
  background: #fff;
  padding: 15px 0;
  box-shadow: 0px 2px 20px rgba(1, 41, 112, 0.1);
}

.header .logo {
  line-height: 0;
}

.header .logo img {
  max-height: 40px;
  margin-right: 6px;
}

.header .logo span {
  font-size: 30px;
  font-weight: 700;
  letter-spacing: 1px;
  color: #012970;
  font-family: "Nunito", sans-serif;
  margin-top: 3px;
}

/*--------------------------------------------------------------
# Navigation Menu
--------------------------------------------------------------*/
/**
* Desktop Navigation 
*/
.navbar {
  padding: 0;
}

.navbar ul {
  margin: 0;
  padding: 0;
  display: flex;
  list-style: none;
  align-items: center;
}

.navbar li {
  position: relative;
}

.navbar a,
.navbar a:focus {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0 10px 30px;
  font-family: "Nunito", sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #013289;
  white-space: nowrap;
  transition: 0.3s;
}

.navbar a i,
.navbar a:focus i {
  font-size: 12px;
  line-height: 0;
  margin-left: 5px;
}

.navbar a:hover,
.navbar .active,
.navbar .active:focus,
.navbar li:hover > a {
  color: #4154f1;
}

.navbar .getstarted,
.navbar .getstarted:focus {
  background: #4154f1;
  padding: 8px 20px;
  margin-left: 30px;
  border-radius: 4px;
  color: #fff;
}

.navbar .getstarted:hover,
.navbar .getstarted:focus:hover {
  color: #fff;
  background: #5969f3;
}

.navbar .dropdown ul {
  display: block;
  position: absolute;
  left: 14px;
  top: calc(100% + 30px);
  margin: 0;
  padding: 10px 0;
  z-index: 99;
  opacity: 0;
  visibility: hidden;
  background: #fff;
  box-shadow: 0px 0px 30px rgba(127, 137, 161, 0.25);
  transition: 0.3s;
  border-radius: 4px;
}

.navbar .dropdown ul li {
  min-width: 200px;
}

.navbar .dropdown ul a {
  padding: 10px 20px;
  font-size: 15px;
  text-transform: none;
  font-weight: 600;
}

.navbar .dropdown ul a i {
  font-size: 12px;
}

.navbar .dropdown ul a:hover,
.navbar .dropdown ul .active:hover,
.navbar .dropdown ul li:hover > a {
  color: #4154f1;
}

.navbar .dropdown:hover > ul {
  opacity: 1;
  top: 100%;
  visibility: visible;
}

.navbar .megamenu {
  position: static;
}

.navbar .megamenu ul {
  margin-top: 5px;
  right: 0;
  padding: 10px;
  display: flex;
}

.navbar .megamenu ul li {
  flex: 1 1;
}

.navbar .megamenu ul li a,
.navbar .megamenu ul li:hover > a {
  color: #013289;
}

.navbar .megamenu ul li a:hover,
.navbar .megamenu ul li .active,
.navbar .megamenu ul li .active:hover {
  color: #4154f1;
}

.navbar .dropdown .dropdown ul {
  top: 0;
  left: calc(100% - 30px);
  visibility: hidden;
}

.navbar .dropdown .dropdown:hover > ul {
  opacity: 1;
  top: 0;
  left: 100%;
  visibility: visible;
}

@media (max-width: 1366px) {
  .navbar .dropdown .dropdown ul {
    left: -90%;
  }

  .navbar .dropdown .dropdown:hover > ul {
    left: -100%;
  }
}

/**
* Mobile Navigation 
*/
.mobile-nav-toggle {
  color: #012970;
  font-size: 28px;
  cursor: pointer;
  display: none;
  line-height: 0;
  transition: 0.5s;
}

.mobile-nav-toggle.bi-x {
  color: #fff;
}

@media (max-width: 1200px) {
  .mobile-nav-toggle {
    display: block;
  }

  .navbar ul {
    display: none;
  }
}

.navbar-mobile {
  position: fixed;
  overflow: hidden;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(1, 22, 61, 0.9);
  transition: 0.3s;
}

.navbar-mobile .mobile-nav-toggle {
  position: absolute;
  top: 15px;
  right: 15px;
}

.navbar-mobile ul {
  display: block;
  position: absolute;
  top: 55px;
  right: 15px;
  bottom: 15px;
  left: 15px;
  padding: 10px 0;
  border-radius: 10px;
  background-color: #fff;
  overflow-y: auto;
  transition: 0.3s;
}

.navbar-mobile a,
.navbar-mobile a:focus {
  padding: 10px 20px;
  font-size: 15px;
  color: #012970;
}

.navbar-mobile a:hover,
.navbar-mobile .active,
.navbar-mobile li:hover > a {
  color: #4154f1;
}

.navbar-mobile .getstarted,
.navbar-mobile .getstarted:focus {
  margin: 15px;
}

.navbar-mobile .dropdown ul {
  position: static;
  display: none;
  margin: 10px 20px;
  padding: 10px 0;
  z-index: 99;
  opacity: 1;
  visibility: visible;
  background: #fff;
  box-shadow: 0px 0px 30px rgba(127, 137, 161, 0.25);
}

.navbar-mobile .dropdown ul li {
  min-width: 200px;
}

.navbar-mobile .dropdown ul a {
  padding: 10px 20px;
}

.navbar-mobile .dropdown ul a i {
  font-size: 12px;
}

.navbar-mobile .dropdown ul a:hover,
.navbar-mobile .dropdown ul .active:hover,
.navbar-mobile .dropdown ul li:hover > a {
  color: #4154f1;
}

.navbar-mobile .dropdown > .dropdown-active {
  display: block;
}

/*--------------------------------------------------------------
# Hero Section
--------------------------------------------------------------*/
.hero {
  width: 100%;
  height: 100vh;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) top center no-repeat;
  background-size: cover;
}

.hero h1 {
  margin: 0;
  font-size: 48px;
  font-weight: 700;
  color: #012970;
}

.hero h2 {
  color: #444444;
  margin: 15px 0 0 0;
  font-size: 18px;
  line-height: 24px;
  font-weight: 400;
}

.hero .btn-get-started {
  margin-top: 30px;
  line-height: 0;
  padding: 15px 40px;
  border-radius: 4px;
  transition: 0.5s;
  color: #fff;
  background: #4154f1;
  box-shadow: 0px 5px 30px rgba(65, 84, 241, 0.4);
}

.hero .btn-get-started span {
  font-family: "Nunito", sans-serif;
  font-weight: 600;
  font-size: 16px;
  letter-spacing: 1px;
}

.hero .btn-get-started i {
  margin-left: 5px;
  font-size: 18px;
  transition: 0.3s;
}

.hero .btn-get-started:hover i {
  transform: translateX(5px);
}

.hero .hero-img {
  text-align: right;
}

@media (min-width: 1024px) {
  .hero {
    background-attachment: fixed;
  }
}

@media (max-width: 991px) {
  .hero {
    height: auto;
    padding: 120px 0 60px 0;
  }

  .hero .hero-img {
    text-align: center;
    margin-top: 80px;
  }

  .hero .hero-img img {
    width: 80%;
  }
}

@media (max-width: 768px) {
  .hero {
    text-align: center;
  }

  .hero h1 {
    font-size: 32px;
  }

  .hero h2 {
    font-size: 24px;
  }

  .hero .hero-img img {
    width: 100%;
  }
}

/*--------------------------------------------------------------
# About
--------------------------------------------------------------*/
.about .content {
  background-color: #f6f9ff;
  padding: 40px;
}

.about h3 {
  font-size: 14px;
  font-weight: 700;
  color: #4154f1;
  text-transform: uppercase;
}

.about h2 {
  font-size: 24px;
  font-weight: 700;
  color: #012970;
}

.about p {
  margin: 15px 0 30px 0;
  line-height: 24px;
}

.about .btn-read-more {
  line-height: 0;
  padding: 15px 40px;
  border-radius: 4px;
  transition: 0.5s;
  color: #fff;
  background: #4154f1;
  box-shadow: 0px 5px 25px rgba(65, 84, 241, 0.3);
}

.about .btn-read-more span {
  font-family: "Nunito", sans-serif;
  font-weight: 600;
  font-size: 16px;
  letter-spacing: 1px;
}

.about .btn-read-more i {
  margin-left: 5px;
  font-size: 18px;
  transition: 0.3s;
}

.about .btn-read-more:hover i {
  transform: translateX(5px);
}

/*--------------------------------------------------------------
# Values
--------------------------------------------------------------*/
.values .box {
  padding: 30px;
  box-shadow: 0px 0 5px rgba(1, 41, 112, 0.08);
  text-align: center;
  transition: 0.3s;
  height: 100%;
}

.values .box img {
  padding: 30px 50px;
  transition: 0.5s;
  transform: scale(1.1);
}

.values .box h3 {
  font-size: 24px;
  color: #012970;
  font-weight: 700;
  margin-bottom: 18px;
}

.values .box:hover {
  box-shadow: 0px 0 30px rgba(1, 41, 112, 0.08);
}

.values .box:hover img {
  transform: scale(1);
}

/*--------------------------------------------------------------
# Pricing
--------------------------------------------------------------*/
.pricing .box {
  padding: 40px 20px;
  background: #fff;
  text-align: center;
  box-shadow: 0px 0 30px rgba(1, 41, 112, 0.08);
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  transition: 0.3s;
}

.pricing .box:hover {
  transform: scale(1.1);
  box-shadow: 0px 0 30px rgba(1, 41, 112, 0.1);
}

.pricing h3 {
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 15px;
}

.pricing .price {
  font-size: 36px;
  color: #444444;
  font-weight: 600;
  font-family: "Poppins", sans-serif;
}

.pricing .price sup {
  font-size: 20px;
  top: -15px;
  left: -3px;
}

.pricing .price span {
  color: #bababa;
  font-size: 16px;
  font-weight: 300;
}

.pricing img {
  padding: 30px 40px;
}

.pricing ul {
  padding: 0;
  list-style: none;
  color: #444444;
  text-align: center;
  line-height: 26px;
  font-size: 16px;
  margin-bottom: 25px;
}

.pricing ul li {
  padding-bottom: 10px;
}

.pricing ul .na {
  color: #ccc;
  text-decoration: line-through;
}

.pricing .btn-buy {
  display: inline-block;
  padding: 8px 40px 10px 40px;
  border-radius: 50px;
  color: #4154f1;
  transition: none;
  font-size: 16px;
  font-weight: 400;
  font-family: "Nunito", sans-serif;
  font-weight: 600;
  transition: 0.3s;
  border: 1px solid #4154f1;
}

.pricing .btn-buy:hover {
  background: #4154f1;
  color: #fff;
}

.pricing .featured {
  width: 200px;
  position: absolute;
  top: 18px;
  right: -68px;
  transform: rotate(45deg);
  z-index: 1;
  font-size: 14px;
  padding: 1px 0 3px 0;
  background: #4154f1;
  color: #fff;
}

/* SCROLLBAR CSS */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  border-left: 0;
  background: rgba(0, 0, 0, 0.1);
}
::-webkit-scrollbar-thumb {
  background: #5d87ff;
  border-radius: 0;
  border-radius: 20px;
}

/*--------------------------------------------------------------
# Portfolio
--------------------------------------------------------------*/
.portfolio #portfolio-flters {
  padding: 0;
  margin: 0 auto 25px auto;
  list-style: none;
  text-align: center;
  background: white;
  border-radius: 50px;
  padding: 2px 15px;
}

.portfolio #portfolio-flters li {
  cursor: pointer;
  display: inline-block;
  padding: 8px 20px 10px 20px;
  font-size: 15px;
  font-weight: 600;
  line-height: 1;
  color: #444444;
  margin: 0 4px 8px 4px;
  transition: 0.3s;
  border-radius: 50px;
  border: 1px solid #fff;
}

.portfolio #portfolio-flters li.filter-active {
  color: #4154f1;
  border-color: #4154f1;
}
.portfolio #portfolio-flters li:hover,
.portfolio #portfolio-flters li.filter-active {
  color: #4154f1;
}

.portfolio #portfolio-flters li:last-child {
  margin-right: 0;
}

/*--------------------------------------------------------------
# Services
--------------------------------------------------------------*/
.services .icon-box {
  padding: 30px;
  position: relative;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 0 29px 0 rgba(68, 88, 144, 0.12);
  transition: all 0.3s ease-in-out;
  border-radius: 8px;
  z-index: 1;
}

.services .icon-box::before {
  content: "";
  position: absolute;
  background: #e1f0fa;
  right: -60px;
  top: -40px;
  width: 100px;
  height: 100px;
  border-radius: 50px;
  transition: all 0.3s;
  z-index: -1;
}

.services .icon-box:hover::before {
  background: #3498db;
  right: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border-radius: 0px;
}

.services .icon {
  margin: 0 auto 20px auto;
  padding-top: 10px;
  display: inline-block;
  text-align: center;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  background: #3498db;
  transition: all 0.3s ease-in-out;
}

.services .icon svg {
  font-size: 36px;
  line-height: 1;
  color: #fff;
}

.services .title {
  font-weight: 700;
  margin-bottom: 15px;
  font-size: 18px;
}

.services .title a {
  color: #111;
}

.services .description {
  font-size: 15px;
  line-height: 28px;
  margin-bottom: 0;
}

.services .icon-box:hover .title a,
.services .icon-box:hover .description {
  color: #fff;
}

.services .icon-box:hover .icon {
  background: #fff;
}

.services .icon-box:hover .icon svg {
  color: #3498db;
}

.feature-boxh3 {
  color: #012970;
  font-weight: 700;
  font-size: 32px;
  margin-bottom: 10px;
}

.btn-all {
  margin-top: 10px;
  line-height: 0;
  padding: 15px 40px;
  border-radius: 4px;
  transition: 0.5s;
  color: #fff;
  background: #4154f1;
  box-shadow: 0px 5px 30px rgba(65, 84, 241, 0.4);
  border: none;
  font-weight: 600;
}

.boxForIcon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  padding: 5px;
  border: 1px solid #e9eaf2;
  border-radius: 5px;
  margin-right: 10px;
  margin-top: 5px;
  max-height: 30px;
}
.inconboxText {
  color: #092d64;
  font-size: 16px;
}

.boxAll {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

/*--------------------------------------------------------------
# Testimonials
--------------------------------------------------------------*/
.testimonials .testimonial-wrap {
  padding-left: 50px;
}

.testimonials .testimonials-carousel,
.testimonials .testimonials-slider {
  overflow: hidden;
}

.testimonials .testimonial-item {
  box-sizing: content-box;
  padding: 30px 30px 30px 60px;
  margin: 30px 15px;
  min-height: 200px;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.08);
  position: relative;
  background: #fff;
}

.testimonials .testimonial-item .testimonial-img {
  width: 90px;
  border-radius: 10px;
  border: 6px solid #fff;
  position: absolute;
  left: -45px;
}

.testimonials .testimonial-item h3 {
  font-size: 18px;
  font-weight: bold;
  margin: 10px 0 5px 0;
  color: #111;
}

.testimonials .testimonial-item h4 {
  font-size: 14px;
  color: #999;
  margin: 0;
}

.testimonials .testimonial-item .quote-icon-left,
.testimonials .testimonial-item .quote-icon-right {
  color: #e1f0fa;
  font-size: 26px;
}

.testimonials .testimonial-item .quote-icon-left {
  display: inline-block;
  left: -5px;
  position: relative;
}

.testimonials .testimonial-item .quote-icon-right {
  display: inline-block;
  right: -5px;
  position: relative;
  top: 10px;
}

.testimonials .testimonial-item p {
  font-style: italic;
  margin: 15px auto 15px auto;
}

.testimonials .swiper-pagination {
  margin-top: 20px;
  position: relative;
}

.testimonials .swiper-pagination .swiper-pagination-bullet {
  width: 12px;
  height: 12px;
  background-color: #fff;
  opacity: 1;
  border: 1px solid #3498db;
}

.testimonials .swiper-pagination .swiper-pagination-bullet-active {
  background-color: #3498db;
}

.testimonialLogo {
  object-fit: contain;
}

@media (max-width: 767px) {
  .testimonials .testimonial-wrap {
    padding-left: 0;
  }

  .testimonials .testimonials-carousel,
  .testimonials .testimonials-slider {
    overflow: hidden;
  }

  .testimonials .testimonial-item {
    padding: 30px;
    margin: 15px;
  }

  .testimonials .testimonial-item .testimonial-img {
    position: static;
    left: auto;
  }
}

/*--------------------------------------------------------------
# Contact
--------------------------------------------------------------*/
.contact .info-box {
  color: #444444;
  background: #fafbff;
  padding: 30px;
}

.contact .info-box i {
  font-size: 38px;
  line-height: 0;
  color: #4154f1;
}

.contact .info-box h3 {
  font-size: 20px;
  color: #012970;
  font-weight: 700;
  margin: 20px 0 10px 0;
}

.contact .info-box p {
  padding: 0;
  line-height: 24px;
  font-size: 14px;
  margin-bottom: 0;
}

.contact .php-email-form {
  background: #fafbff;
  padding: 30px;
  height: 100%;
}

.contact .php-email-form .error-message {
  display: none;
  color: #fff;
  background: #ed3c0d;
  text-align: left;
  padding: 15px;
  margin-bottom: 24px;
  font-weight: 600;
}

.contact .php-email-form .sent-message {
  display: none;
  color: #fff;
  background: #18d26e;
  text-align: center;
  padding: 15px;
  margin-bottom: 24px;
  font-weight: 600;
}

.contact .php-email-form .loading {
  display: none;
  background: #fff;
  text-align: center;
  padding: 15px;
  margin-bottom: 24px;
}

.contact .php-email-form .loading:before {
  content: "";
  display: inline-block;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  margin: 0 10px -6px 0;
  border: 3px solid #18d26e;
  border-top-color: #eee;
  animation: animate-loading 1s linear infinite;
}

.contact .php-email-form input,
.contact .php-email-form textarea {
  border-radius: 0;
  box-shadow: none;
  font-size: 14px;
  border-radius: 0;
}

.contact .php-email-form input:focus,
.contact .php-email-form textarea:focus {
  border-color: #4154f1;
}

.contact .php-email-form input[type="text"],
.contact .php-email-form input[type="email"] {
  padding: 10px 15px;
}

.contact .php-email-form textarea {
  padding: 12px 15px;
}

.contact .php-email-form button[type="submit"] {
  background: #4154f1;
  border: 0;
  padding: 10px 30px;
  color: #fff;
  transition: 0.4s;
  border-radius: 4px;
}

.contact .php-email-form button[type="submit"]:hover {
  background: #5969f3;
}

@keyframes animate-loading {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes animate-loading {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.slick-active > button {
  background: #4154f1 !important;
}

.slick-dots > li {
  background-color: #8b97ff;
}

.boxShadow {
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,
    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  border-radius: 5px;
  font-size: 14px;
}

.dbtn {
  border: none;
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,
    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  padding: 5px 10px;
  border-radius: 2px;
}

/*--------------------------------------------------------------
# Footer
--------------------------------------------------------------*/
.footer {
  background: #f6f9ff;
  padding: 0 0 30px 0;
  font-size: 14px;
}

.footer .footer-newsletter {
  padding: 50px 0;
  background: #f6f9ff;
  border-top: 1px solid #e1ecff;
}

.footer .footer-newsletter h4 {
  font-size: 24px;
  margin: 0 0 10px 0;
  padding: 0;
  line-height: 1;
  font-weight: 700;
  color: #012970;
}

.footer .footer-newsletter form {
  margin-top: 20px;
  background: #fff;
  padding: 6px 10px;
  position: relative;
  border-radius: 4px;
  border: 1px solid #e1ecff;
}

.footer .footer-newsletter form input[type="email"] {
  border: 0;
  padding: 8px;
  width: calc(100% - 140px);
}

.footer .footer-newsletter form input[type="submit"] {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  border: 0;
  background: none;
  font-size: 16px;
  padding: 0 30px;
  margin: 3px;
  background: #4154f1;
  color: #fff;
  transition: 0.3s;
  border-radius: 4px;
}

.footer .footer-newsletter form input[type="submit"]:hover {
  background: #5969f3;
}

.footer .footer-top {
  background: white url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right top;
  background-size: contain;
  border-top: 1px solid #e1ecff;
  border-bottom: 1px solid #e1ecff;
  padding: 60px 0 30px 0;
}

@media (max-width: 992px) {
  .footer .footer-top {
    background-position: center bottom;
  }
}

.footer .footer-top .footer-info {
  margin-bottom: 30px;
}

.footer .footer-top .footer-info .logo {
  line-height: 0;
  margin-bottom: 15px;
}

.footer .footer-top .footer-info .logo img {
  max-height: 40px;
  margin-right: 6px;
}

.footer .footer-top .footer-info .logo span {
  font-size: 30px;
  font-weight: 700;
  letter-spacing: 1px;
  color: #012970;
  font-family: "Nunito", sans-serif;
  margin-top: 3px;
}

.footer .footer-top .footer-info p {
  font-size: 14px;
  line-height: 24px;
  margin-bottom: 0;
  font-family: "Nunito", sans-serif;
}

.footer .footer-top .social-links a {
  font-size: 20px;
  display: inline-block;
  color: rgba(1, 41, 112, 0.5);
  line-height: 0;
  margin-right: 10px;
  transition: 0.3s;
}

.footer .footer-top .social-links a:hover {
  color: #012970;
}

.footer .footer-top h4 {
  font-size: 16px;
  font-weight: bold;
  color: #012970;
  text-transform: uppercase;
  position: relative;
  padding-bottom: 12px;
}

.footer .footer-top .footer-links {
  margin-bottom: 30px;
}

.footer .footer-top .footer-links ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer .footer-top .footer-links ul i {
  padding-right: 2px;
  color: #d0d4fc;
  font-size: 12px;
  line-height: 0;
}

.footer .footer-top .footer-links ul li {
  padding: 10px 0;
  display: flex;
  align-items: center;
}

.footer .footer-top .footer-links ul li:first-child {
  padding-top: 0;
}

.footer .footer-top .footer-links ul a {
  color: #013289;
  transition: 0.3s;
  display: inline-block;
  line-height: 1;
}

.footer .footer-top .footer-links ul a:hover {
  color: #4154f1;
}

.footer .footer-top .footer-contact p {
  line-height: 26px;
}

.footer .copyright {
  text-align: center;
  padding-top: 30px;
  color: #012970;
}

.footer .credits {
  padding-top: 10px;
  text-align: center;
  font-size: 13px;
  color: #012970;
}

.dashHeading {
  font-weight: 600;
  margin-bottom: 1rem;
}
.footerVideo {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #2979ff;
  color: white;
  height: 40px;
  cursor: pointer;
  font-weight: 600;
}

.middleBox {
  padding-inline: 5px;
}

.container1 {
  position: relative;
}

.image1 {
  opacity: 1;
  display: block;
  transition: 0.5s ease;
  backface-visibility: hidden;
}

.middle1 {
  transition: 0.5s ease;
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}

.container1:hover .image1 {
  filter: blur(8px);
}

.container1:hover .middle1 {
  opacity: 1;
}

.stroke-dotted {
  opacity: 0;
  stroke-dasharray: 4, 5;
  stroke-width: 1px;
  transform-origin: 50% 50%;
  animation: spin 4s infinite linear;
  transition: opacity 1s ease, stroke-width 1s ease;
}
.stroke-solid {
  stroke-dashoffset: 0;
  stroke-dasharray: 300;
  stroke-width: 4px;
  transition: stroke-dashoffset 1s ease, opacity 1s ease;
}

.icon {
  transform-origin: 50% 50%;
  transition: transform 200ms ease-out;
}

#play:hover {
  .stroke-dotted {
    stroke-width: 4px;
    opacity: 1;
  }
  .stroke-solid {
    opacity: 0;
    stroke-dashoffset: 300;
  }
  .icon {
    transform: scale(1.05);
  }
}

#play {
  cursor: pointer;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
}
.dragbox {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 3.4px dotted blue;
  width: 100px;
  height: 100px;
  border-radius: 5px;
}

.draggDownBox {
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-radius: 16px;
  background-color: #e1e1e1;
  width: 640px;
  margin-top: 20px;
}
.draginnerBox {
  overflow: hidden;
  width: 100px;
  height: 100px;
  border-radius: 16px;
  margin: 10px;
  cursor: pointer;
  object-fit: cover;
}

.draginnerBox:hover {
  border: 3px solid rgb(0, 0, 255);
  transform: scale(1.1);
  transition: 0.4s;
}

/* usecase */
.features .icon-box {
  display: flex;
  align-items: center;
  padding: 15px;
  background: #f6f6f6;
  transition: ease-in-out 0.3s;
  border-radius: 8px;
}

.features .icon-box svg {
  font-size: 40px;
  padding-right: 10px;
  line-height: 1;
}

.features .icon-box h3 {
  font-weight: 700;
  margin: 0;
  padding: 0;
  line-height: 1;
  font-size: 16px;
}

.features .icon-box h3 a {
  color: #222222;
  transition: ease-in-out 0.3s;
}

.features .icon-box h3 a:hover {
  color: #3498db;
}

.features .icon-box:hover {
  background: #eef7fc;
}

.headingReport {
  font-weight: 500;
}

.fortHeadingTerm {
  margin-top: 1rem;
  font-weight: 600;
  font-size: 18px;
}

.termP {
  margin-block: 0.5rem;
  line-height: 24px;
}

.reportBox {
  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px,
    rgb(209, 213, 219) 0px 0px 0px 1px inset;
  border-radius: 8px;
}
.graphBoxShadow {
  box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 12px;
  padding: 10px;
  border-radius: 8px;
}

.iconCross {
  position: absolute;
  top: 10px;
  right: 20px;
  cursor: pointer;
  font-weight: 800;
}

.card2 {
  width: max-content;
  display: flex;
  flex-direction: column;
  border-radius: 0.5rem;
  inset: 0;
  padding: 1rem;
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,
    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
  font-family: "Nunito", sans-serif;
}

.cardInnerBox {
  display: flex;
}

.icon2 {
  height: 2rem;
  width: 2rem;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  background-color: #3b82f6;
  color: #fff;
}

.content2 {
  font-family: "Nunito", sans-serif;
  margin-left: 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
}

.title2 {
  font-family: "Nunito", sans-serif;
  margin-bottom: 0.25rem;
  font-size: 15px;
  line-height: 1.25rem;
  font-weight: 700;
  color: #1d6ff1;
  text-transform: capitalize;
}

.desc2 {
  font-family: "Nunito", sans-serif;
  margin-bottom: 0.5rem;
  font-size: 13.5px;
  line-height: 1.25rem;
  font-weight: 700;
  color: rgb(114, 114, 114);
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA,WAAW;AACX;EACE,wBAAwB;EACxB,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;;;;;;EAME,iCAAiC;AACnC;;AAEA;;+DAE+D;AAC/D;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,wCAAwC;EACxC,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,OAAO;EACP,QAAQ;EACR,UAAU;EACV,UAAU;EACV,2BAA2B;EAC3B,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,OAAO;EACP,MAAM;EACN,UAAU;EACV,YAAY;EACZ,4BAA4B;EAC5B,6CAA6C;EAC7C,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,2DAA2D;AAC7D;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;;+DAE+D;AAC/D;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;;+DAE+D;AAC/D;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;;+DAE+D;AAC/D;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;;+DAE+D;AAC/D;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;;+DAE+D;AAC/D;EACE,oBAAoB;EACpB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,iCAAiC;EACjC,eAAe;AACjB;;AAEA;;+DAE+D;AAC/D;;CAEC;AACD;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,kDAAkD;EAClD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;AACf;;AAEA;EACE,SAAO;AACT;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,MAAM;EACN,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,MAAM;EACN,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;;CAEC;AACD;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,MAAM;EACN,QAAQ;EACR,OAAO;EACP,SAAS;EACT,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;+DAE+D;AAC/D;EACE,WAAW;EACX,aAAa;EACb,wEAAsE;EACtE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;;+DAE+D;AAC/D;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;+DAE+D;AAC/D;EACE,aAAa;EACb,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;+DAE+D;AAC/D;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,6CAA6C;EAC7C,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,wBAAwB;EACxB,UAAU;EACV,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;+DAE+D;AAC/D;EACE,UAAU;EACV,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;;+DAE+D;AAC/D;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,8CAA8C;EAC9C,gCAAgC;EAChC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,QAAQ;EACR,MAAM;EACN,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,+CAA+C;EAC/C,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;;+DAE+D;AAC/D;EACE,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,iBAAiB;EACjB,iBAAiB;EACjB,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,UAAU;EACZ;AACF;;AAEA;;+DAE+D;AAC/D;EACE,cAAc;EACd,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;0CACwC;EACxC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ;0CACwC;EACxC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;+DAE+D;AAC/D;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6EAA6E;EAC7E,wBAAwB;EACxB,6BAA6B;EAC7B,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,4BAA4B;EAC5B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,kCAAkC;EAClC,iDAAiD;AACnD;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;EACjB,sDAAsD;AACxD;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE;IACE,iBAAiB;IACjB,UAAU;EACZ;EACA;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,4CAA4C;AAC9C;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE;4CAC0C;EAC1C,kBAAkB;AACpB;AACA;EACE,4CAA4C;EAC5C,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,aAAa;EACb;0CACwC;EACxC,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;AAC3B","sourcesContent":["@import url(\"https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i|Nunito:300,300i,400,400i,600,600i,700,700i|Poppins:300,300i,400,400i,500,500i,600,600i,700,700i\");\n\n/* Colors */\n:root {\n  --color-default: #fafafa;\n  --color-primary: #27a776;\n  --color-secondary: #161718;\n}\n\n/* Smooth scroll behavior */\n:root {\n  scroll-behavior: smooth;\n}\n\nbody {\n  font-family: \"Open Sans\", sans-serif;\n  color: #444444;\n}\n* {\n  font-family: \"Nunito\", sans-serif;\n}\n\na {\n  color: #4154f1;\n  text-decoration: none !important;\n}\n\na:hover {\n  color: #717ff5;\n  text-decoration: none !important;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: \"Nunito\", sans-serif;\n}\n\n/*--------------------------------------------------------------\n# Preloader\n--------------------------------------------------------------*/\n#preloader {\n  display: flex;\n  position: fixed;\n  inset: 0;\n  width: 100%;\n  height: 100vh;\n  z-index: 99999;\n}\n\n#preloader:before,\n#preloader:after {\n  content: \"\";\n  background-color: var(--color-secondary);\n  position: absolute;\n  inset: 0;\n  width: 50%;\n  height: 100%;\n  transition: all 0.3s ease 0s;\n  z-index: -1;\n}\n\n#preloader:after {\n  left: auto;\n  right: 0;\n}\n\n#preloader .line {\n  position: relative;\n  overflow: hidden;\n  margin: auto;\n  width: 1px;\n  height: 280px;\n  transition: all 0.8s ease 0s;\n}\n\n#preloader .line:before {\n  content: \"\";\n  position: absolute;\n  background-color: #fff;\n  left: 0;\n  top: 50%;\n  width: 1px;\n  height: 0%;\n  transform: translateY(-50%);\n  animation: lineincrease 1000ms ease-in-out 0s forwards;\n}\n\n#preloader .line:after {\n  content: \"\";\n  position: absolute;\n  background-color: #999;\n  left: 0;\n  top: 0;\n  width: 1px;\n  height: 100%;\n  transform: translateY(-100%);\n  animation: linemove 1200ms linear 0s infinite;\n  animation-delay: 2000ms;\n}\n\n#preloader.loaded .line {\n  opacity: 0;\n  height: 100% !important;\n}\n\n#preloader.loaded .line:after {\n  opacity: 0;\n}\n\n#preloader.loaded:before,\n#preloader.loaded:after {\n  animation: preloaderfinish 300ms ease-in-out 500ms forwards;\n}\n\n@keyframes lineincrease {\n  0% {\n    height: 0%;\n  }\n\n  100% {\n    height: 100%;\n  }\n}\n\n@keyframes linemove {\n  0% {\n    transform: translateY(200%);\n  }\n\n  100% {\n    transform: translateY(-100%);\n  }\n}\n\n@keyframes preloaderfinish {\n  0% {\n    width: 5 0%;\n  }\n\n  100% {\n    width: 0%;\n  }\n}\n\n/*--------------------------------------------------------------\n# Sections\n--------------------------------------------------------------*/\nsection {\n  padding: 60px 0;\n  overflow: hidden;\n}\n\n.section-header {\n  text-align: center;\n  padding-bottom: 40px;\n}\n\n.section-header h2 {\n  font-size: 13px;\n  letter-spacing: 1px;\n  font-weight: 700;\n  margin: 0;\n  color: #4154f1;\n  text-transform: uppercase;\n}\n\n.section-header p {\n  margin: 10px 0 0 0;\n  padding: 0;\n  font-size: 38px;\n  line-height: 42px;\n  font-weight: 700;\n  color: #012970;\n}\n\n@media (max-width: 768px) {\n  .section-header p {\n    font-size: 28px;\n    line-height: 32px;\n  }\n}\n\n/*--------------------------------------------------------------\n# Breadcrumbs\n--------------------------------------------------------------*/\n.breadcrumbs {\n  padding: 15px 0;\n  background: #012970;\n  min-height: 40px;\n  margin-top: 82px;\n  color: #fff;\n}\n\n@media (max-width: 992px) {\n  .breadcrumbs {\n    margin-top: 57px;\n  }\n}\n\n.breadcrumbs h2 {\n  font-size: 28px;\n  font-weight: 500;\n}\n\n.breadcrumbs ol {\n  display: flex;\n  flex-wrap: wrap;\n  list-style: none;\n  padding: 0 0 10px 0;\n  margin: 0;\n  font-size: 14px;\n}\n\n.breadcrumbs ol a {\n  color: #fff;\n  transition: 0.3s;\n}\n\n.breadcrumbs ol a:hover {\n  text-decoration: underline;\n}\n\n.breadcrumbs ol li + li {\n  padding-left: 10px;\n}\n\n.breadcrumbs ol li + li::before {\n  display: inline-block;\n  padding-right: 10px;\n  color: #8894f6;\n  content: \"/\";\n}\n\n/*--------------------------------------------------------------\n# Back to top button\n--------------------------------------------------------------*/\n.back-to-top {\n  position: fixed;\n  visibility: hidden;\n  opacity: 0;\n  right: 15px;\n  bottom: 15px;\n  z-index: 99999;\n  background: #4154f1;\n  width: 30px;\n  height: 30px;\n  border-radius: 4px;\n  transition: all 0.4s;\n}\n\n.back-to-top i {\n  font-size: 24px;\n  color: #fff;\n  line-height: 0;\n}\n\n.back-to-top:hover {\n  background: #6776f4;\n  color: #fff;\n}\n\n.back-to-top.active {\n  visibility: visible;\n  opacity: 1;\n}\n\n/*--------------------------------------------------------------\n# Disable aos animation delay on mobile devices\n--------------------------------------------------------------*/\n@media screen and (max-width: 768px) {\n  [data-aos-delay] {\n    transition-delay: 0 !important;\n  }\n}\n\n/*--------------------------------------------------------------\n# Header\n--------------------------------------------------------------*/\n.header {\n  transition: all 0.5s;\n  z-index: 997;\n  padding: 20px 0;\n}\n\n.header.header-scrolled {\n  background: #fff;\n  padding: 15px 0;\n  box-shadow: 0px 2px 20px rgba(1, 41, 112, 0.1);\n}\n\n.header .logo {\n  line-height: 0;\n}\n\n.header .logo img {\n  max-height: 40px;\n  margin-right: 6px;\n}\n\n.header .logo span {\n  font-size: 30px;\n  font-weight: 700;\n  letter-spacing: 1px;\n  color: #012970;\n  font-family: \"Nunito\", sans-serif;\n  margin-top: 3px;\n}\n\n/*--------------------------------------------------------------\n# Navigation Menu\n--------------------------------------------------------------*/\n/**\n* Desktop Navigation \n*/\n.navbar {\n  padding: 0;\n}\n\n.navbar ul {\n  margin: 0;\n  padding: 0;\n  display: flex;\n  list-style: none;\n  align-items: center;\n}\n\n.navbar li {\n  position: relative;\n}\n\n.navbar a,\n.navbar a:focus {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 0 10px 30px;\n  font-family: \"Nunito\", sans-serif;\n  font-size: 16px;\n  font-weight: 700;\n  color: #013289;\n  white-space: nowrap;\n  transition: 0.3s;\n}\n\n.navbar a i,\n.navbar a:focus i {\n  font-size: 12px;\n  line-height: 0;\n  margin-left: 5px;\n}\n\n.navbar a:hover,\n.navbar .active,\n.navbar .active:focus,\n.navbar li:hover > a {\n  color: #4154f1;\n}\n\n.navbar .getstarted,\n.navbar .getstarted:focus {\n  background: #4154f1;\n  padding: 8px 20px;\n  margin-left: 30px;\n  border-radius: 4px;\n  color: #fff;\n}\n\n.navbar .getstarted:hover,\n.navbar .getstarted:focus:hover {\n  color: #fff;\n  background: #5969f3;\n}\n\n.navbar .dropdown ul {\n  display: block;\n  position: absolute;\n  left: 14px;\n  top: calc(100% + 30px);\n  margin: 0;\n  padding: 10px 0;\n  z-index: 99;\n  opacity: 0;\n  visibility: hidden;\n  background: #fff;\n  box-shadow: 0px 0px 30px rgba(127, 137, 161, 0.25);\n  transition: 0.3s;\n  border-radius: 4px;\n}\n\n.navbar .dropdown ul li {\n  min-width: 200px;\n}\n\n.navbar .dropdown ul a {\n  padding: 10px 20px;\n  font-size: 15px;\n  text-transform: none;\n  font-weight: 600;\n}\n\n.navbar .dropdown ul a i {\n  font-size: 12px;\n}\n\n.navbar .dropdown ul a:hover,\n.navbar .dropdown ul .active:hover,\n.navbar .dropdown ul li:hover > a {\n  color: #4154f1;\n}\n\n.navbar .dropdown:hover > ul {\n  opacity: 1;\n  top: 100%;\n  visibility: visible;\n}\n\n.navbar .megamenu {\n  position: static;\n}\n\n.navbar .megamenu ul {\n  margin-top: 5px;\n  right: 0;\n  padding: 10px;\n  display: flex;\n}\n\n.navbar .megamenu ul li {\n  flex: 1;\n}\n\n.navbar .megamenu ul li a,\n.navbar .megamenu ul li:hover > a {\n  color: #013289;\n}\n\n.navbar .megamenu ul li a:hover,\n.navbar .megamenu ul li .active,\n.navbar .megamenu ul li .active:hover {\n  color: #4154f1;\n}\n\n.navbar .dropdown .dropdown ul {\n  top: 0;\n  left: calc(100% - 30px);\n  visibility: hidden;\n}\n\n.navbar .dropdown .dropdown:hover > ul {\n  opacity: 1;\n  top: 0;\n  left: 100%;\n  visibility: visible;\n}\n\n@media (max-width: 1366px) {\n  .navbar .dropdown .dropdown ul {\n    left: -90%;\n  }\n\n  .navbar .dropdown .dropdown:hover > ul {\n    left: -100%;\n  }\n}\n\n/**\n* Mobile Navigation \n*/\n.mobile-nav-toggle {\n  color: #012970;\n  font-size: 28px;\n  cursor: pointer;\n  display: none;\n  line-height: 0;\n  transition: 0.5s;\n}\n\n.mobile-nav-toggle.bi-x {\n  color: #fff;\n}\n\n@media (max-width: 1200px) {\n  .mobile-nav-toggle {\n    display: block;\n  }\n\n  .navbar ul {\n    display: none;\n  }\n}\n\n.navbar-mobile {\n  position: fixed;\n  overflow: hidden;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  background: rgba(1, 22, 61, 0.9);\n  transition: 0.3s;\n}\n\n.navbar-mobile .mobile-nav-toggle {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n}\n\n.navbar-mobile ul {\n  display: block;\n  position: absolute;\n  top: 55px;\n  right: 15px;\n  bottom: 15px;\n  left: 15px;\n  padding: 10px 0;\n  border-radius: 10px;\n  background-color: #fff;\n  overflow-y: auto;\n  transition: 0.3s;\n}\n\n.navbar-mobile a,\n.navbar-mobile a:focus {\n  padding: 10px 20px;\n  font-size: 15px;\n  color: #012970;\n}\n\n.navbar-mobile a:hover,\n.navbar-mobile .active,\n.navbar-mobile li:hover > a {\n  color: #4154f1;\n}\n\n.navbar-mobile .getstarted,\n.navbar-mobile .getstarted:focus {\n  margin: 15px;\n}\n\n.navbar-mobile .dropdown ul {\n  position: static;\n  display: none;\n  margin: 10px 20px;\n  padding: 10px 0;\n  z-index: 99;\n  opacity: 1;\n  visibility: visible;\n  background: #fff;\n  box-shadow: 0px 0px 30px rgba(127, 137, 161, 0.25);\n}\n\n.navbar-mobile .dropdown ul li {\n  min-width: 200px;\n}\n\n.navbar-mobile .dropdown ul a {\n  padding: 10px 20px;\n}\n\n.navbar-mobile .dropdown ul a i {\n  font-size: 12px;\n}\n\n.navbar-mobile .dropdown ul a:hover,\n.navbar-mobile .dropdown ul .active:hover,\n.navbar-mobile .dropdown ul li:hover > a {\n  color: #4154f1;\n}\n\n.navbar-mobile .dropdown > .dropdown-active {\n  display: block;\n}\n\n/*--------------------------------------------------------------\n# Hero Section\n--------------------------------------------------------------*/\n.hero {\n  width: 100%;\n  height: 100vh;\n  background: url(../public/assets/img/hero-bg.png) top center no-repeat;\n  background-size: cover;\n}\n\n.hero h1 {\n  margin: 0;\n  font-size: 48px;\n  font-weight: 700;\n  color: #012970;\n}\n\n.hero h2 {\n  color: #444444;\n  margin: 15px 0 0 0;\n  font-size: 18px;\n  line-height: 24px;\n  font-weight: 400;\n}\n\n.hero .btn-get-started {\n  margin-top: 30px;\n  line-height: 0;\n  padding: 15px 40px;\n  border-radius: 4px;\n  transition: 0.5s;\n  color: #fff;\n  background: #4154f1;\n  box-shadow: 0px 5px 30px rgba(65, 84, 241, 0.4);\n}\n\n.hero .btn-get-started span {\n  font-family: \"Nunito\", sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  letter-spacing: 1px;\n}\n\n.hero .btn-get-started i {\n  margin-left: 5px;\n  font-size: 18px;\n  transition: 0.3s;\n}\n\n.hero .btn-get-started:hover i {\n  transform: translateX(5px);\n}\n\n.hero .hero-img {\n  text-align: right;\n}\n\n@media (min-width: 1024px) {\n  .hero {\n    background-attachment: fixed;\n  }\n}\n\n@media (max-width: 991px) {\n  .hero {\n    height: auto;\n    padding: 120px 0 60px 0;\n  }\n\n  .hero .hero-img {\n    text-align: center;\n    margin-top: 80px;\n  }\n\n  .hero .hero-img img {\n    width: 80%;\n  }\n}\n\n@media (max-width: 768px) {\n  .hero {\n    text-align: center;\n  }\n\n  .hero h1 {\n    font-size: 32px;\n  }\n\n  .hero h2 {\n    font-size: 24px;\n  }\n\n  .hero .hero-img img {\n    width: 100%;\n  }\n}\n\n/*--------------------------------------------------------------\n# About\n--------------------------------------------------------------*/\n.about .content {\n  background-color: #f6f9ff;\n  padding: 40px;\n}\n\n.about h3 {\n  font-size: 14px;\n  font-weight: 700;\n  color: #4154f1;\n  text-transform: uppercase;\n}\n\n.about h2 {\n  font-size: 24px;\n  font-weight: 700;\n  color: #012970;\n}\n\n.about p {\n  margin: 15px 0 30px 0;\n  line-height: 24px;\n}\n\n.about .btn-read-more {\n  line-height: 0;\n  padding: 15px 40px;\n  border-radius: 4px;\n  transition: 0.5s;\n  color: #fff;\n  background: #4154f1;\n  box-shadow: 0px 5px 25px rgba(65, 84, 241, 0.3);\n}\n\n.about .btn-read-more span {\n  font-family: \"Nunito\", sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  letter-spacing: 1px;\n}\n\n.about .btn-read-more i {\n  margin-left: 5px;\n  font-size: 18px;\n  transition: 0.3s;\n}\n\n.about .btn-read-more:hover i {\n  transform: translateX(5px);\n}\n\n/*--------------------------------------------------------------\n# Values\n--------------------------------------------------------------*/\n.values .box {\n  padding: 30px;\n  box-shadow: 0px 0 5px rgba(1, 41, 112, 0.08);\n  text-align: center;\n  transition: 0.3s;\n  height: 100%;\n}\n\n.values .box img {\n  padding: 30px 50px;\n  transition: 0.5s;\n  transform: scale(1.1);\n}\n\n.values .box h3 {\n  font-size: 24px;\n  color: #012970;\n  font-weight: 700;\n  margin-bottom: 18px;\n}\n\n.values .box:hover {\n  box-shadow: 0px 0 30px rgba(1, 41, 112, 0.08);\n}\n\n.values .box:hover img {\n  transform: scale(1);\n}\n\n/*--------------------------------------------------------------\n# Pricing\n--------------------------------------------------------------*/\n.pricing .box {\n  padding: 40px 20px;\n  background: #fff;\n  text-align: center;\n  box-shadow: 0px 0 30px rgba(1, 41, 112, 0.08);\n  border-radius: 4px;\n  position: relative;\n  overflow: hidden;\n  transition: 0.3s;\n}\n\n.pricing .box:hover {\n  transform: scale(1.1);\n  box-shadow: 0px 0 30px rgba(1, 41, 112, 0.1);\n}\n\n.pricing h3 {\n  font-weight: 700;\n  font-size: 18px;\n  margin-bottom: 15px;\n}\n\n.pricing .price {\n  font-size: 36px;\n  color: #444444;\n  font-weight: 600;\n  font-family: \"Poppins\", sans-serif;\n}\n\n.pricing .price sup {\n  font-size: 20px;\n  top: -15px;\n  left: -3px;\n}\n\n.pricing .price span {\n  color: #bababa;\n  font-size: 16px;\n  font-weight: 300;\n}\n\n.pricing img {\n  padding: 30px 40px;\n}\n\n.pricing ul {\n  padding: 0;\n  list-style: none;\n  color: #444444;\n  text-align: center;\n  line-height: 26px;\n  font-size: 16px;\n  margin-bottom: 25px;\n}\n\n.pricing ul li {\n  padding-bottom: 10px;\n}\n\n.pricing ul .na {\n  color: #ccc;\n  text-decoration: line-through;\n}\n\n.pricing .btn-buy {\n  display: inline-block;\n  padding: 8px 40px 10px 40px;\n  border-radius: 50px;\n  color: #4154f1;\n  transition: none;\n  font-size: 16px;\n  font-weight: 400;\n  font-family: \"Nunito\", sans-serif;\n  font-weight: 600;\n  transition: 0.3s;\n  border: 1px solid #4154f1;\n}\n\n.pricing .btn-buy:hover {\n  background: #4154f1;\n  color: #fff;\n}\n\n.pricing .featured {\n  width: 200px;\n  position: absolute;\n  top: 18px;\n  right: -68px;\n  transform: rotate(45deg);\n  z-index: 1;\n  font-size: 14px;\n  padding: 1px 0 3px 0;\n  background: #4154f1;\n  color: #fff;\n}\n\n/* SCROLLBAR CSS */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n  border-left: 0;\n  background: rgba(0, 0, 0, 0.1);\n}\n::-webkit-scrollbar-thumb {\n  background: #5d87ff;\n  border-radius: 0;\n  border-radius: 20px;\n}\n\n/*--------------------------------------------------------------\n# Portfolio\n--------------------------------------------------------------*/\n.portfolio #portfolio-flters {\n  padding: 0;\n  margin: 0 auto 25px auto;\n  list-style: none;\n  text-align: center;\n  background: white;\n  border-radius: 50px;\n  padding: 2px 15px;\n}\n\n.portfolio #portfolio-flters li {\n  cursor: pointer;\n  display: inline-block;\n  padding: 8px 20px 10px 20px;\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 1;\n  color: #444444;\n  margin: 0 4px 8px 4px;\n  transition: 0.3s;\n  border-radius: 50px;\n  border: 1px solid #fff;\n}\n\n.portfolio #portfolio-flters li.filter-active {\n  color: #4154f1;\n  border-color: #4154f1;\n}\n.portfolio #portfolio-flters li:hover,\n.portfolio #portfolio-flters li.filter-active {\n  color: #4154f1;\n}\n\n.portfolio #portfolio-flters li:last-child {\n  margin-right: 0;\n}\n\n/*--------------------------------------------------------------\n# Services\n--------------------------------------------------------------*/\n.services .icon-box {\n  padding: 30px;\n  position: relative;\n  overflow: hidden;\n  background: #fff;\n  box-shadow: 0 0 29px 0 rgba(68, 88, 144, 0.12);\n  transition: all 0.3s ease-in-out;\n  border-radius: 8px;\n  z-index: 1;\n}\n\n.services .icon-box::before {\n  content: \"\";\n  position: absolute;\n  background: #e1f0fa;\n  right: -60px;\n  top: -40px;\n  width: 100px;\n  height: 100px;\n  border-radius: 50px;\n  transition: all 0.3s;\n  z-index: -1;\n}\n\n.services .icon-box:hover::before {\n  background: #3498db;\n  right: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 0px;\n}\n\n.services .icon {\n  margin: 0 auto 20px auto;\n  padding-top: 10px;\n  display: inline-block;\n  text-align: center;\n  border-radius: 50%;\n  width: 60px;\n  height: 60px;\n  background: #3498db;\n  transition: all 0.3s ease-in-out;\n}\n\n.services .icon svg {\n  font-size: 36px;\n  line-height: 1;\n  color: #fff;\n}\n\n.services .title {\n  font-weight: 700;\n  margin-bottom: 15px;\n  font-size: 18px;\n}\n\n.services .title a {\n  color: #111;\n}\n\n.services .description {\n  font-size: 15px;\n  line-height: 28px;\n  margin-bottom: 0;\n}\n\n.services .icon-box:hover .title a,\n.services .icon-box:hover .description {\n  color: #fff;\n}\n\n.services .icon-box:hover .icon {\n  background: #fff;\n}\n\n.services .icon-box:hover .icon svg {\n  color: #3498db;\n}\n\n.feature-boxh3 {\n  color: #012970;\n  font-weight: 700;\n  font-size: 32px;\n  margin-bottom: 10px;\n}\n\n.btn-all {\n  margin-top: 10px;\n  line-height: 0;\n  padding: 15px 40px;\n  border-radius: 4px;\n  transition: 0.5s;\n  color: #fff;\n  background: #4154f1;\n  box-shadow: 0px 5px 30px rgba(65, 84, 241, 0.4);\n  border: none;\n  font-weight: 600;\n}\n\n.boxForIcon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 30px;\n  padding: 5px;\n  border: 1px solid #e9eaf2;\n  border-radius: 5px;\n  margin-right: 10px;\n  margin-top: 5px;\n  max-height: 30px;\n}\n.inconboxText {\n  color: #092d64;\n  font-size: 16px;\n}\n\n.boxAll {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n\n/*--------------------------------------------------------------\n# Testimonials\n--------------------------------------------------------------*/\n.testimonials .testimonial-wrap {\n  padding-left: 50px;\n}\n\n.testimonials .testimonials-carousel,\n.testimonials .testimonials-slider {\n  overflow: hidden;\n}\n\n.testimonials .testimonial-item {\n  box-sizing: content-box;\n  padding: 30px 30px 30px 60px;\n  margin: 30px 15px;\n  min-height: 200px;\n  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.08);\n  position: relative;\n  background: #fff;\n}\n\n.testimonials .testimonial-item .testimonial-img {\n  width: 90px;\n  border-radius: 10px;\n  border: 6px solid #fff;\n  position: absolute;\n  left: -45px;\n}\n\n.testimonials .testimonial-item h3 {\n  font-size: 18px;\n  font-weight: bold;\n  margin: 10px 0 5px 0;\n  color: #111;\n}\n\n.testimonials .testimonial-item h4 {\n  font-size: 14px;\n  color: #999;\n  margin: 0;\n}\n\n.testimonials .testimonial-item .quote-icon-left,\n.testimonials .testimonial-item .quote-icon-right {\n  color: #e1f0fa;\n  font-size: 26px;\n}\n\n.testimonials .testimonial-item .quote-icon-left {\n  display: inline-block;\n  left: -5px;\n  position: relative;\n}\n\n.testimonials .testimonial-item .quote-icon-right {\n  display: inline-block;\n  right: -5px;\n  position: relative;\n  top: 10px;\n}\n\n.testimonials .testimonial-item p {\n  font-style: italic;\n  margin: 15px auto 15px auto;\n}\n\n.testimonials .swiper-pagination {\n  margin-top: 20px;\n  position: relative;\n}\n\n.testimonials .swiper-pagination .swiper-pagination-bullet {\n  width: 12px;\n  height: 12px;\n  background-color: #fff;\n  opacity: 1;\n  border: 1px solid #3498db;\n}\n\n.testimonials .swiper-pagination .swiper-pagination-bullet-active {\n  background-color: #3498db;\n}\n\n.testimonialLogo {\n  object-fit: contain;\n}\n\n@media (max-width: 767px) {\n  .testimonials .testimonial-wrap {\n    padding-left: 0;\n  }\n\n  .testimonials .testimonials-carousel,\n  .testimonials .testimonials-slider {\n    overflow: hidden;\n  }\n\n  .testimonials .testimonial-item {\n    padding: 30px;\n    margin: 15px;\n  }\n\n  .testimonials .testimonial-item .testimonial-img {\n    position: static;\n    left: auto;\n  }\n}\n\n/*--------------------------------------------------------------\n# Contact\n--------------------------------------------------------------*/\n.contact .info-box {\n  color: #444444;\n  background: #fafbff;\n  padding: 30px;\n}\n\n.contact .info-box i {\n  font-size: 38px;\n  line-height: 0;\n  color: #4154f1;\n}\n\n.contact .info-box h3 {\n  font-size: 20px;\n  color: #012970;\n  font-weight: 700;\n  margin: 20px 0 10px 0;\n}\n\n.contact .info-box p {\n  padding: 0;\n  line-height: 24px;\n  font-size: 14px;\n  margin-bottom: 0;\n}\n\n.contact .php-email-form {\n  background: #fafbff;\n  padding: 30px;\n  height: 100%;\n}\n\n.contact .php-email-form .error-message {\n  display: none;\n  color: #fff;\n  background: #ed3c0d;\n  text-align: left;\n  padding: 15px;\n  margin-bottom: 24px;\n  font-weight: 600;\n}\n\n.contact .php-email-form .sent-message {\n  display: none;\n  color: #fff;\n  background: #18d26e;\n  text-align: center;\n  padding: 15px;\n  margin-bottom: 24px;\n  font-weight: 600;\n}\n\n.contact .php-email-form .loading {\n  display: none;\n  background: #fff;\n  text-align: center;\n  padding: 15px;\n  margin-bottom: 24px;\n}\n\n.contact .php-email-form .loading:before {\n  content: \"\";\n  display: inline-block;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  margin: 0 10px -6px 0;\n  border: 3px solid #18d26e;\n  border-top-color: #eee;\n  animation: animate-loading 1s linear infinite;\n}\n\n.contact .php-email-form input,\n.contact .php-email-form textarea {\n  border-radius: 0;\n  box-shadow: none;\n  font-size: 14px;\n  border-radius: 0;\n}\n\n.contact .php-email-form input:focus,\n.contact .php-email-form textarea:focus {\n  border-color: #4154f1;\n}\n\n.contact .php-email-form input[type=\"text\"],\n.contact .php-email-form input[type=\"email\"] {\n  padding: 10px 15px;\n}\n\n.contact .php-email-form textarea {\n  padding: 12px 15px;\n}\n\n.contact .php-email-form button[type=\"submit\"] {\n  background: #4154f1;\n  border: 0;\n  padding: 10px 30px;\n  color: #fff;\n  transition: 0.4s;\n  border-radius: 4px;\n}\n\n.contact .php-email-form button[type=\"submit\"]:hover {\n  background: #5969f3;\n}\n\n@keyframes animate-loading {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes animate-loading {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.slick-active > button {\n  background: #4154f1 !important;\n}\n\n.slick-dots > li {\n  background-color: #8b97ff;\n}\n\n.boxShadow {\n  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,\n    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;\n  border-radius: 5px;\n  font-size: 14px;\n}\n\n.dbtn {\n  border: none;\n  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,\n    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;\n  padding: 5px 10px;\n  border-radius: 2px;\n}\n\n/*--------------------------------------------------------------\n# Footer\n--------------------------------------------------------------*/\n.footer {\n  background: #f6f9ff;\n  padding: 0 0 30px 0;\n  font-size: 14px;\n}\n\n.footer .footer-newsletter {\n  padding: 50px 0;\n  background: #f6f9ff;\n  border-top: 1px solid #e1ecff;\n}\n\n.footer .footer-newsletter h4 {\n  font-size: 24px;\n  margin: 0 0 10px 0;\n  padding: 0;\n  line-height: 1;\n  font-weight: 700;\n  color: #012970;\n}\n\n.footer .footer-newsletter form {\n  margin-top: 20px;\n  background: #fff;\n  padding: 6px 10px;\n  position: relative;\n  border-radius: 4px;\n  border: 1px solid #e1ecff;\n}\n\n.footer .footer-newsletter form input[type=\"email\"] {\n  border: 0;\n  padding: 8px;\n  width: calc(100% - 140px);\n}\n\n.footer .footer-newsletter form input[type=\"submit\"] {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  border: 0;\n  background: none;\n  font-size: 16px;\n  padding: 0 30px;\n  margin: 3px;\n  background: #4154f1;\n  color: #fff;\n  transition: 0.3s;\n  border-radius: 4px;\n}\n\n.footer .footer-newsletter form input[type=\"submit\"]:hover {\n  background: #5969f3;\n}\n\n.footer .footer-top {\n  background: white url(../public/assets/img/footer-bg.png) no-repeat right top;\n  background-size: contain;\n  border-top: 1px solid #e1ecff;\n  border-bottom: 1px solid #e1ecff;\n  padding: 60px 0 30px 0;\n}\n\n@media (max-width: 992px) {\n  .footer .footer-top {\n    background-position: center bottom;\n  }\n}\n\n.footer .footer-top .footer-info {\n  margin-bottom: 30px;\n}\n\n.footer .footer-top .footer-info .logo {\n  line-height: 0;\n  margin-bottom: 15px;\n}\n\n.footer .footer-top .footer-info .logo img {\n  max-height: 40px;\n  margin-right: 6px;\n}\n\n.footer .footer-top .footer-info .logo span {\n  font-size: 30px;\n  font-weight: 700;\n  letter-spacing: 1px;\n  color: #012970;\n  font-family: \"Nunito\", sans-serif;\n  margin-top: 3px;\n}\n\n.footer .footer-top .footer-info p {\n  font-size: 14px;\n  line-height: 24px;\n  margin-bottom: 0;\n  font-family: \"Nunito\", sans-serif;\n}\n\n.footer .footer-top .social-links a {\n  font-size: 20px;\n  display: inline-block;\n  color: rgba(1, 41, 112, 0.5);\n  line-height: 0;\n  margin-right: 10px;\n  transition: 0.3s;\n}\n\n.footer .footer-top .social-links a:hover {\n  color: #012970;\n}\n\n.footer .footer-top h4 {\n  font-size: 16px;\n  font-weight: bold;\n  color: #012970;\n  text-transform: uppercase;\n  position: relative;\n  padding-bottom: 12px;\n}\n\n.footer .footer-top .footer-links {\n  margin-bottom: 30px;\n}\n\n.footer .footer-top .footer-links ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.footer .footer-top .footer-links ul i {\n  padding-right: 2px;\n  color: #d0d4fc;\n  font-size: 12px;\n  line-height: 0;\n}\n\n.footer .footer-top .footer-links ul li {\n  padding: 10px 0;\n  display: flex;\n  align-items: center;\n}\n\n.footer .footer-top .footer-links ul li:first-child {\n  padding-top: 0;\n}\n\n.footer .footer-top .footer-links ul a {\n  color: #013289;\n  transition: 0.3s;\n  display: inline-block;\n  line-height: 1;\n}\n\n.footer .footer-top .footer-links ul a:hover {\n  color: #4154f1;\n}\n\n.footer .footer-top .footer-contact p {\n  line-height: 26px;\n}\n\n.footer .copyright {\n  text-align: center;\n  padding-top: 30px;\n  color: #012970;\n}\n\n.footer .credits {\n  padding-top: 10px;\n  text-align: center;\n  font-size: 13px;\n  color: #012970;\n}\n\n.dashHeading {\n  font-weight: 600;\n  margin-bottom: 1rem;\n}\n.footerVideo {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #2979ff;\n  color: white;\n  height: 40px;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.middleBox {\n  padding-inline: 5px;\n}\n\n.container1 {\n  position: relative;\n}\n\n.image1 {\n  opacity: 1;\n  display: block;\n  transition: 0.5s ease;\n  backface-visibility: hidden;\n}\n\n.middle1 {\n  transition: 0.5s ease;\n  opacity: 0;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  text-align: center;\n}\n\n.container1:hover .image1 {\n  filter: blur(8px);\n}\n\n.container1:hover .middle1 {\n  opacity: 1;\n}\n\n.stroke-dotted {\n  opacity: 0;\n  stroke-dasharray: 4, 5;\n  stroke-width: 1px;\n  transform-origin: 50% 50%;\n  animation: spin 4s infinite linear;\n  transition: opacity 1s ease, stroke-width 1s ease;\n}\n.stroke-solid {\n  stroke-dashoffset: 0;\n  stroke-dasharray: 300;\n  stroke-width: 4px;\n  transition: stroke-dashoffset 1s ease, opacity 1s ease;\n}\n\n.icon {\n  transform-origin: 50% 50%;\n  transition: transform 200ms ease-out;\n}\n\n#play:hover {\n  .stroke-dotted {\n    stroke-width: 4px;\n    opacity: 1;\n  }\n  .stroke-solid {\n    opacity: 0;\n    stroke-dashoffset: 300;\n  }\n  .icon {\n    transform: scale(1.05);\n  }\n}\n\n#play {\n  cursor: pointer;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateY(-50%) translateX(-50%);\n}\n.dragbox {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 3.4px dotted blue;\n  width: 100px;\n  height: 100px;\n  border-radius: 5px;\n}\n\n.draggDownBox {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  border-radius: 16px;\n  background-color: #e1e1e1;\n  width: 640px;\n  margin-top: 20px;\n}\n.draginnerBox {\n  overflow: hidden;\n  width: 100px;\n  height: 100px;\n  border-radius: 16px;\n  margin: 10px;\n  cursor: pointer;\n  object-fit: cover;\n}\n\n.draginnerBox:hover {\n  border: 3px solid rgb(0, 0, 255);\n  transform: scale(1.1);\n  transition: 0.4s;\n}\n\n/* usecase */\n.features .icon-box {\n  display: flex;\n  align-items: center;\n  padding: 15px;\n  background: #f6f6f6;\n  transition: ease-in-out 0.3s;\n  border-radius: 8px;\n}\n\n.features .icon-box svg {\n  font-size: 40px;\n  padding-right: 10px;\n  line-height: 1;\n}\n\n.features .icon-box h3 {\n  font-weight: 700;\n  margin: 0;\n  padding: 0;\n  line-height: 1;\n  font-size: 16px;\n}\n\n.features .icon-box h3 a {\n  color: #222222;\n  transition: ease-in-out 0.3s;\n}\n\n.features .icon-box h3 a:hover {\n  color: #3498db;\n}\n\n.features .icon-box:hover {\n  background: #eef7fc;\n}\n\n.headingReport {\n  font-weight: 500;\n}\n\n.fortHeadingTerm {\n  margin-top: 1rem;\n  font-weight: 600;\n  font-size: 18px;\n}\n\n.termP {\n  margin-block: 0.5rem;\n  line-height: 24px;\n}\n\n.reportBox {\n  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px,\n    rgb(209, 213, 219) 0px 0px 0px 1px inset;\n  border-radius: 8px;\n}\n.graphBoxShadow {\n  box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 12px;\n  padding: 10px;\n  border-radius: 8px;\n}\n\n.iconCross {\n  position: absolute;\n  top: 10px;\n  right: 20px;\n  cursor: pointer;\n  font-weight: 800;\n}\n\n.card2 {\n  width: max-content;\n  display: flex;\n  flex-direction: column;\n  border-radius: 0.5rem;\n  inset: 0;\n  padding: 1rem;\n  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,\n    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;\n  font-family: \"Nunito\", sans-serif;\n}\n\n.cardInnerBox {\n  display: flex;\n}\n\n.icon2 {\n  height: 2rem;\n  width: 2rem;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 0.5rem;\n  background-color: #3b82f6;\n  color: #fff;\n}\n\n.content2 {\n  font-family: \"Nunito\", sans-serif;\n  margin-left: 0.75rem;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  font-weight: 400;\n}\n\n.title2 {\n  font-family: \"Nunito\", sans-serif;\n  margin-bottom: 0.25rem;\n  font-size: 15px;\n  line-height: 1.25rem;\n  font-weight: 700;\n  color: #1d6ff1;\n  text-transform: capitalize;\n}\n\n.desc2 {\n  font-family: \"Nunito\", sans-serif;\n  margin-bottom: 0.5rem;\n  font-size: 13.5px;\n  line-height: 1.25rem;\n  font-weight: 700;\n  color: rgb(114, 114, 114);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
